export const boostersLocations:number[][] = [
    [3,3],[3,9],[9,3],[9,15],[15,3],[15,9],
    [6,6],[6,9],[9,6],[9,9],[9,12],[12,6],[12,9]
]